export default [
  {
    label: 'Checklist Maintenance',
    value: 'ChecklistMaintenanceDetail',
  },
];
